var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "org-tree-layout" },
      [
        _c("swb-popover-org-tree", {
          attrs: {
            bizDepart: true,
            showIncludeSubComs: false,
            initIncludeSubComs: false
          },
          on: {
            "notity-change": function($event) {
              _vm.checkComCatChange($event)
            }
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _vm.channelCode == "bizParamComn"
      ? _c("div", { staticClass: "simple-form" }, [
          _c("div", { staticClass: "form-group center" }, [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c(
                  "el-radio-group",
                  {
                    model: {
                      value: _vm.comInfo.postOrgEnabled,
                      callback: function($$v) {
                        _vm.$set(_vm.comInfo, "postOrgEnabled", $$v)
                      },
                      expression: "comInfo.postOrgEnabled"
                    }
                  },
                  [
                    _c(
                      "el-radio",
                      { staticClass: "radio", attrs: { label: false } },
                      [_vm._v("否")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-radio",
                      { staticClass: "radio", attrs: { label: true } },
                      [_vm._v("是")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _vm._m(1),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c(
                  "el-radio-group",
                  {
                    model: {
                      value: _vm.comInfo.postGoodsCatEnabled,
                      callback: function($$v) {
                        _vm.$set(_vm.comInfo, "postGoodsCatEnabled", $$v)
                      },
                      expression: "comInfo.postGoodsCatEnabled"
                    }
                  },
                  [
                    _c(
                      "el-radio",
                      { staticClass: "radio", attrs: { label: false } },
                      [_vm._v("否")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-radio",
                      { staticClass: "radio", attrs: { label: true } },
                      [_vm._v("是")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _vm._m(2),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c(
                  "el-radio-group",
                  {
                    model: {
                      value: _vm.comInfo.postServcCatEnabled,
                      callback: function($$v) {
                        _vm.$set(_vm.comInfo, "postServcCatEnabled", $$v)
                      },
                      expression: "comInfo.postServcCatEnabled"
                    }
                  },
                  [
                    _c(
                      "el-radio",
                      { staticClass: "radio", attrs: { label: false } },
                      [_vm._v("否")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-radio",
                      { staticClass: "radio", attrs: { label: true } },
                      [_vm._v("是")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _vm.comInfo.shopFlag
            ? _c("div", { staticClass: "form-group center" }, [
                _vm._m(3),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-value" },
                  [
                    _c("el-input", {
                      staticClass: "width-1-5x",
                      attrs: { type: "number" },
                      model: {
                        value: _vm.comInfo.autoInvalidAfterNoRspInHours,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.comInfo,
                            "autoInvalidAfterNoRspInHours",
                            $$v
                          )
                        },
                        expression: "comInfo.autoInvalidAfterNoRspInHours"
                      }
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v("小时      注: 值为0时不自动作废")])
                  ],
                  1
                )
              ])
            : _vm._e()
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.channelCode == "bizParamRepair" && _vm.comInfo.shopFlag
      ? _c("div", { staticClass: "simple-form" }, [
          _c("div", { staticClass: "form-group center" }, [
            _vm._m(4),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c(
                  "el-radio-group",
                  {
                    model: {
                      value: _vm.comInfo.performFlag,
                      callback: function($$v) {
                        _vm.$set(_vm.comInfo, "performFlag", $$v)
                      },
                      expression: "comInfo.performFlag"
                    }
                  },
                  [
                    _c(
                      "el-radio",
                      { staticClass: "radio", attrs: { label: 1 } },
                      [_vm._v("保底")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-radio",
                      { staticClass: "radio", attrs: { label: 2 } },
                      [_vm._v("计件")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _vm.comInfo.performFlag == 2
            ? _c("div", { staticClass: "form-group center" }, [
                _vm._m(5),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-value" },
                  [
                    _c("el-input", {
                      staticClass: "align-right",
                      attrs: { type: "number", max: 100, min: 0, step: "1" },
                      model: {
                        value: _vm.comInfo.jbRatio,
                        callback: function($$v) {
                          _vm.$set(_vm.comInfo, "jbRatio", $$v)
                        },
                        expression: "comInfo.jbRatio"
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "input-tip error" }, [
                      _vm._v("0% ~ 100%")
                    ])
                  ],
                  1
                )
              ])
            : _vm._e()
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.channelCode == "bizParamComn" ||
    (_vm.channelCode == "bizParamRepair" && _vm.comInfo.shopFlag)
      ? _c("div", { staticClass: "form-row align-center mt20" }, [
          _c(
            "a",
            {
              staticClass: "swb-btn mb20",
              attrs: { id: "saveBtn" },
              on: {
                click: function($event) {
                  _vm.submitForm()
                }
              }
            },
            [_vm._v("保存")]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", { staticClass: "required" }, [_vm._v("开启岗位组织")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", { staticClass: "required" }, [_vm._v("开启岗位商品分类")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", { staticClass: "required" }, [_vm._v("开启岗位服务分类")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", { staticClass: "required" }, [
        _vm._v("工单派工后(X小时)未响应-自动作废")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", { staticClass: "required" }, [_vm._v("工单默认绩效标记")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", { staticClass: "required" }, [_vm._v("默认计件比率(%)")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-381da05c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-381da05c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/bizParam/OrgBizParamList.vue
// module id = 2801
// module chunks = 1